<template>
	<div class="flex gap-2">
		<AtomStar
			v-for="fill of stars"
			:key="`atom-stars-${fill}`"
			:fill="fill"
		/>
	</div>
</template>

<script setup lang="ts">
type Props = {
	rating: number;
};

const props = defineProps<Props>();

const stars = ref<(0 | 0.5 | 1)[]>([]);

onMounted(() => {
	for (let i = 1; i <= 5; i++) {
		if (props.rating - i >= -0.25) {
			stars.value.push(1);
		}
		else if (props.rating - i > -1) {
			stars.value.push(0.5);
		}
		else {
			stars.value.push(0);
		}
	}
});
</script>
